export class InvalidLocationError extends Error {
  readonly city: string | undefined;

  readonly street: string | undefined;

  constructor({
    cause,
    city,
    street,
  }: {
    cause: string;
    city?: string;
    street?: string;
  }) {
    super(`Failed to obtain location in listing search page.`, { cause });

    this.city = city;
    this.street = street;
  }

  toJSON() {
    return {
      message: this.message,
      cause: this.cause,
      city: this.city,
      street: this.street,
    };
  }
}
